import { BffApiClient, type BffApiClientConfig } from './BffApiClient';

/**
 * Authenticated BFF (Backend For Frontend) API client.
 * Extends BffApiClient and adds authentication capabilities.
 * This client exposes authentication methods and can send auth tokens.
 * Type-safe: Only allows endpoints defined in BFF_ENDPOINTS.
 */
export class BffAuthenticatedApiClient extends BffApiClient {
  private static authenticatedInstance: BffAuthenticatedApiClient | null = null;

  private constructor(config: BffApiClientConfig) {
    super(config);
  }

  /**
   * Get singleton instance of Authenticated BFF API client
   */
  static override getInstance(): BffAuthenticatedApiClient {
    const config = BffApiClient.getConfig();

    BffAuthenticatedApiClient.authenticatedInstance ||= new BffAuthenticatedApiClient(config);
    return BffAuthenticatedApiClient.authenticatedInstance;
  }

  /**
   * Initialize the API client with configuration (shared with BffApiClient)
   */
  static override initialize(config: BffApiClientConfig): void {
    super.initialize(config);
    BffAuthenticatedApiClient.authenticatedInstance = null; // Reset instance to use new config
  }

  /**
   * Reset both instance and configuration (useful for testing initialization)
   */
  static override resetInstance(): void {
    super.resetInstance();
    BffAuthenticatedApiClient.authenticatedInstance = null;
  }
}
